(function () {
    document.addEventListener('DOMContentLoaded', () => {
        // 1. 隐藏jekka app 的entry button
        const inject = () => {
            const root = document.getElementById('hello-jekka-chat-box')?.shadowRoot;
            if (!root) return false;
            if (root.getElementById('hide-chat-bubble-style')) return true; // 防止重复
            const style = document.createElement('style');
            style.id = 'hide-chat-bubble-style';
            style.textContent = `.chat-entry-button { display: none !important; }`;
            root.appendChild(style);
            return true;
        }
        if (!inject()) setTimeout(inject, 1000); // 组件晚加载时兜底

        // 2. 获取jekka app中的entry button
        const getBtn = () => {
            const jekkaShadowHost = document.getElementById('hello-jekka-chat-box');
            const jekkaShadowRoot = jekkaShadowHost?.shadowRoot;
            const jekkaChatButton = jekkaShadowRoot?.querySelector('.chat-entry-button');
            return jekkaChatButton || null;
        };

        // 3. 点击header中的customer service button 触发原生app的entry button的点击事件
        document.addEventListener('click', async (e) => {
            const trigger = e.target.closest('[data-open-livechat]');
            if (!trigger) return;
            e.preventDefault();

            // 立即尝试一次,失败就等1秒再试一次
            let btn = getBtn();
            if (!btn) {
                await new Promise(r => setTimeout(r, 1000));
                btn = getBtn();
            }

            if (btn) {
                btn.click()
            } else {
                console.warn('[custom] jekka button not found.');
            }
        });
    });
})();

